/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';
import Cookies from 'universal-cookie';
import isDesktopMobileTablet from '../../../app/helpers/DesktopMobile/isDesktopMobileTablet';

const brandIdsByHostName = {
    '800flowers': '18F',
    harryanddavid: 'HD',
    '800baskets': '18B',
    simplychocolate: 'SCH',
    fruitbouquets: 'FBQ',
    cheryls: 'CCO',
    personalizationuniverse: 'PZU',
    thepopcornfactory: 'TPF',
    wolfermans: 'WLF',
    stockyards: 'SY',
    berries: 'BRY',
    personalizationmall: 'PML',
    vitalchoice: 'VC',
    thingsremembered: 'TR',
    florists: 'FL',
    cardisle: 'CI',
    celebrations: 'CSG',
};

export const getBrandIdByHostName = (hostname) => {
    let brandId = mbpUtil.getEnv('APP_BRAND_ID') || '18F';

    Object.keys(brandIdsByHostName).forEach((key) => {
        if (hostname.indexOf(key) !== -1) {
            brandId = brandIdsByHostName[key];
        }
    });

    return brandId;
};

export const isWineAvailable = (data) => {
    let availability = false;
    if (!data?.wineAvailability) {
        return false;
    }
    const keys = Object.keys(data.wineAvailability);
    keys.forEach((key) => {
        if (data.wineAvailability[key]?.isProductAvailable) {
            availability = true;
        }
    });
    return availability;
};

export const mockSSREnvironment = (hostname, location) => {
    const mockSSRConfig = {};
    const cookies = new Cookies();
    const sv = cookies.get('sv');
    mockSSRConfig.deviceType = isDesktopMobileTablet();
    mockSSRConfig.isBot = false;
    mockSSRConfig.hostname = hostname;
    mockSSRConfig.path = location.pathname;
    mockSSRConfig.userAgent = navigator.userAgent;
    mockSSRConfig.sv = sv;
    return mockSSRConfig;
};

export const getSCIandSGParams = (sgCustomParams = {}, sku = '') => {
    const sciParams = {};
    if (sku && sgCustomParams) {
        sciParams.source = sgCustomParams[sku]?.source;
        sciParams.SCILocNumber = sgCustomParams[sku]?.SCILocNumber;
    }

    return sciParams;
};

export default {};
